export default "__VITE_ASSET__D3VNfP5k__"